import {CommonModule} from '@angular/common';
import {Component, Inject} from '@angular/core';
import {PaymentProvider} from '@gatewee/types/provider';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {TuiAlertService, TuiDialogContext} from '@taiga-ui/core';
import {POLYMORPHEUS_CONTEXT} from '@taiga-ui/polymorpheus';
import {Observable} from 'rxjs';
import {GateweeButtonComponent} from '../../gatewee-button/gatewee-button.component';

interface DialogData {
  id: number;
  submitCredentialsFn: (
    provider: PaymentProvider,
    payload: unknown,
  ) => Observable<void>;
  provider: PaymentProvider;
}

@Component({
  selector: 'app-sandbox-credentials',
  templateUrl: './sandbox-credentials.component.html',
  styleUrls: ['./sandbox-credentials.component.css'],
  standalone: true,
  imports: [CommonModule, TranslateModule, GateweeButtonComponent],
})
export class SandboxCredentialsComponent {
  submitting = false;
  submitCredentialsFn!: (
    provider: PaymentProvider,
    payload: unknown,
  ) => Observable<void>;
  provider!: PaymentProvider;

  constructor(
    private alerts: TuiAlertService,
    private translate: TranslateService,
    @Inject(POLYMORPHEUS_CONTEXT)
    private readonly context: TuiDialogContext<boolean, DialogData>,
  ) {
    this.submitCredentialsFn = this.context.data.submitCredentialsFn;
    this.provider = this.context.data.provider;
  }

  submit(): void {
    if (this.submitting) {
      return;
    }

    this.submitting = true;

    let handledSuccess = false;
    const handleSuccess = () => {
      if (handledSuccess) {
        return;
      }
      handledSuccess = true;
      this.alerts
        .open(
          this.translate.instant(
            'features.integrations.credentials.success.message',
          ),
          {
            label: this.translate.instant(
              'features.integrations.credentials.success.title',
            ),
            appearance: 'success',
          },
        )
        .subscribe();
      this.context.completeWith(true);
    };

    this.submitCredentialsFn(this.provider, {}).subscribe({
      next: () => handleSuccess(),
      complete: () => handleSuccess(),
      error: () => {
        this.alerts
          .open(
            this.translate.instant(
              'features.integrations.credentials.error.message',
            ),
            {
              label: this.translate.instant(
                'features.integrations.credentials.error.title',
              ),
              appearance: 'error',
            },
          )
          .subscribe();
        this.submitting = false;
      },
    });
  }

  close(): void {
    this.context.completeWith(false);
  }
}
